import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './logindatastyles.css'; 
import supabase from '../supabaseClient'; 

const LoginData = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);

    const {  error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setMessage(`Error: ${error.message}`);
    } else {
      setMessage('Sign-in successful!');
      navigate('/'); // Redirect to the home page after successful sign-in
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <h2 className="login-title">Sign In</h2>
      <form onSubmit={handleSignIn} className="login-form">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="login-input"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="login-input"
        />
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </button>
      </form>
      {message && <p className="login-message">{message}</p>}
      <div className="forgot-password">
        <a href="/forgot_password">Forgot Password?</a>
      </div>
    </div>
  );
};

export default LoginData;
